<template>
  <div
    class="bg-f7fafe w-full h-270px uploader-border flex justify-center mt-2"
  >
    <div
      class="flex justify-center cursor-pointer h-full items-center"
      @drop="handleDrop"
      @dragover="handleDragover"
      @dragenter="handleDragover"
      @click="$refs.imageInput.click()"
    >
      <div class="text-center">
        <UploadIcon class="mx-auto" />
        <div class="mt-4">
          <p class="fsize16">Drop file or click here to upload or</p>
          <p class="text-primary fsize16">Browse</p>
        </div>
      </div>
    </div>
    <div>
      <input
        ref="imageInput"
        @change="handleClick"
        type="file"
        accept="image/*"
        class="hidden"
      />
    </div>
  </div>
</template>

<script>
import { UploadIcon } from "vue-feather-icons";
export default {
  components: {
    UploadIcon,
  },
  props: {
    onSuccess: {
      type: Function,
      required: true,
    },
    accept: {
      type: String,
      default: "image",
    },
  },
  methods: {
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$vs.notify({
          title: "Warning",
          text: "Only support uploading one file!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
        return;
      }
      const rawFile = files[0];
      this.uploadImage(rawFile);
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadImage(rawFile);
    },
    uploadImage(file) {
      this.$refs["imageInput"].value = null; // fix can't select the same image
      if (file.type === "application/pdf") {
        this.$vs.notify({
          title: "Warning",
          text: "PDF files are not allowed. Please select an image.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
        return;
      }
      this.renderImage(file);
    },
    renderImage(file) {
      this.onSuccess && this.onSuccess(file);
    },
  },
};
</script>

<style scoped>
.bg-f7fafe {
  background-color: #f7fafe;
}
.h-270px {
  height: 270px;
}
</style>
